var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRenameJobi = function SvgRenameJobi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M16 21a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1V6h-1a1 1 0 0 1-1-1 1 1 0 0 1 1-1h4a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-1v13h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1zm-3.8-2.11a1.1 1.1 0 0 1-.38-.29 2.7 2.7 0 0 1-.32-.56l-.3-.68-.62-1.58H5.32l-.61 1.62a5.5 5.5 0 0 1-.62 1.27 1 1 0 0 1-.84.33 1.26 1.26 0 0 1-.87-.35 1.07 1.07 0 0 1-.38-.8 1.6 1.6 0 0 1 .09-.53c.06-.19.15-.44.29-.77l3.3-8.16.35-.84a4 4 0 0 1 .42-.83 1.64 1.64 0 0 1 .6-.52 1.8 1.8 0 0 1 .9-.2 1.86 1.86 0 0 1 .9.2 1.8 1.8 0 0 1 .6.52 3.8 3.8 0 0 1 .38.68l.39.98 3.38 8.1a3.9 3.9 0 0 1 .4 1.35 1.1 1.1 0 0 1-.38.8 1.25 1.25 0 0 1-.9.37 1.2 1.2 0 0 1-.53-.1zM6 13.87h3.87L7.93 8.68z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRenameJobi);
export default ForwardRef;